import React, { memo } from 'react';
import BlockMarkdown from './BlockMarkdown';
import ClaimSupportFooter from '../ClaimSupportFooter';
import { extractBlockItems } from './structuredBlockUtils';
import styles from './structuredResponse.module.css';

const DEFAULT_COLUMNS = [
    { key: 'risk', label: 'Risk' },
    { key: 'severity', label: 'Severity' },
    { key: 'likelihood', label: 'Likelihood' },
    { key: 'owner', label: 'Owner' },
    { key: 'status', label: 'Status' },
];

function RiskMatrixBlock({ block, renderContext }) {
    const rows = extractBlockItems(block);
    if (!rows.length) return null;

    const columns =
        Array.isArray(block.columns) && block.columns.length
            ? block.columns.map(col => (typeof col === 'string' ? { key: col, label: col } : col))
            : DEFAULT_COLUMNS;

    return (
        <section className={styles.riskMatrixBlock} aria-label={block.title || 'Risk matrix'}>
            {block.title ? <h3 className={styles.blockTitle}>{block.title}</h3> : null}
            <div className={styles.tableWrap}>
                <table className={styles.riskMatrixTable}>
                    <thead>
                        <tr>
                            {columns.map(col => (
                                <th key={col.key || col.label} scope="col">
                                    {col.label || col.key}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, rowIndex) => (
                            <tr key={row.id || `risk-${rowIndex}`}>
                                {columns.map(col => {
                                    const key = col.key || col.label;
                                    const value = row[key];
                                    const isMarkdownField = key === 'risk' || key === 'description';
                                    return (
                                        <td key={`${row.id || rowIndex}-${key}`}>
                                            {isMarkdownField && typeof value === 'string' ? (
                                                <BlockMarkdown content={value} {...renderContext} />
                                            ) : (
                                                value ?? '—'
                                            )}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <ClaimSupportFooter block={block} renderContext={renderContext} />
        </section>
    );
}

export default memo(RiskMatrixBlock);
